interface Config {
    API_URL: string;
    CLIENT_ID: string;
}

const getEnvironment = () => {
    const hostUrl = window.location.hostname;
    if (hostUrl.includes("localhost")) {
        return "sandbox"
    }
    if (hostUrl.includes('dev')) {
        return 'dev';
    }
    if (hostUrl.includes('uat')) {
        return 'uat';
    }
    return 'prod';
};

const sandboxConfig: Config = {
    // API_URL: 'https://localhost:8443/jarvis/v1/chat/completions',
    API_URL: 'https://vwrboabfm7rfwuegdcg2jhznz40pifmh.lambda-url.us-east-1.on.aws/',
    // API_URL: 'https://c.ai.cambridgeassociates.cloud/jarvis/v1/chat/completions',
    CLIENT_ID: '9d24bed3-51e6-435c-ab35-90f73808a46c'
};

const developmentConfig: Config = {
    API_URL: 'https://c.ai.dev.cambridgeassociates.cloud/jarvis/v1/chat/completions',
    CLIENT_ID: '9d24bed3-51e6-435c-ab35-90f73808a46c'
};

const uatConfig: Config = {
    API_URL: 'https://c.ai.uat.cambridgeassociates.cloud/jarvis/v1/chat/completions',
    CLIENT_ID: '946fbbbb-9ae4-47a4-8903-660575d09ce5'
};

const productionConfig: Config = {
    // API_URL: 'https://c.ai.cambridgeassociates.cloud/jarvis/v1/chat/completions',
    API_URL: 'https://vwrboabfm7rfwuegdcg2jhznz40pifmh.lambda-url.us-east-1.on.aws/',
    CLIENT_ID: 'ab39a089-9f93-4244-9af1-f9392ad116ba'
};

const configs = {
    sandbox: sandboxConfig,
    dev: developmentConfig,
    uat: uatConfig,
    prod: productionConfig
};

export const config = configs[getEnvironment()];
